// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3d-bd","addWidgetButton":"Header_addWidgetButton__2JIwP","dashboardTabs":"Header_dashboardTabs__3oeay","active":"Header_active__fA2PR"};